var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.dialogVisible) ? _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("工资发放汇总表")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "#FFFFFF",
      "margin": "0px 40px",
      "border": "1px solid #eaebed"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-left": "46px",
      "padding-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('span', [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "collapse-tags": "",
      "props": _vm.props,
      "clearable": ""
    },
    model: {
      value: (_vm.condition.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.condition, "organize_ids", $$v)
      },
      expression: "condition.organize_ids"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("日期")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "month",
      "placeholder": "请选择",
      "value-format": "yyyy-MM"
    },
    model: {
      value: (_vm.condition.years_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "years_date", $$v)
      },
      expression: "condition.years_date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": function($event) {
        return _vm.examine(null)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t代发")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": function($event) {
        return _vm.grant(null)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t发放")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": function($event) {
        return _vm.openfileUrl()
      }
    }
  }, [_vm._v("导入")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.dialogVisibledr,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledr = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-upload', {
    ref: "adModel",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "multiple": "",
      "file-list": _vm.fileList,
      "on-success": _vm.handleAvatarSuccess,
      "on-remove": _vm.handleRemove
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t选择文件")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.fileDatatitle) ? _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("导入失败项目名单：\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.fileData), function(item, index) {
    return _c('div', {
      staticStyle: {
        "flex": "1",
        "width": "calc((100% - 20px) / 5)",
        "min-width": "calc((100% - 20px) / 5)",
        "max-width": "calc((100% - 20px) / 5)"
      }
    }, [_c('div', [_vm._v(_vm._s(item))])])
  }), 0)]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px solid #006E4B",
      "margin": "30px 0 0 40%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.savefileUrl()
      }
    }
  }, [_vm._v("确 定")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    attrs: {
      "fields": _vm.download_excel,
      "title": "工资发放汇总表",
      "name": "工资发放汇总表.xls",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t导出")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "10px 2%",
      "margin-top": "20px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "border": true,
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "show-summary": _vm.showSum,
      "summary-method": _vm.getSummaries,
      "height": "530",
      "tooltip-effect": "dark",
      "expand-row-keys": _vm.expands
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "select-all": _vm.handleSelectAll,
      "select": _vm.handleSelect,
      "click": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-table', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.detailsList.length > 0),
            expression: "scope.row.detailsList.length > 0"
          }],
          ref: "table",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "header-cell-style": {
              background: '#edeff1',
              color: '#000000'
            },
            "border": true,
            "data": scope.row.detailsList,
            "height": "400",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChanges,
            "select": _vm.handleSelects
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "align": "center",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "align": "center",
            "label": "序号",
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope_1) {
              return [_vm._v(_vm._s(scope_1.$index + 1))]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "staff_name",
            "align": "center",
            "label": "员工姓名",
            "width": "100"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "after_tax_paid_salary",
            "align": "center",
            "label": "实发工资(税后)",
            "width": "120"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "receiving_method",
            "align": "center",
            "label": "领取方式",
            "width": "80"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "bank_card_number",
            "align": "center",
            "label": "银行卡号",
            "width": "150"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "cardholder_name",
            "align": "center",
            "label": "持卡人姓名",
            "width": "100"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "entry_name",
            "align": "center",
            "label": "项目名称",
            "width": "200"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id_card",
            "align": "center",
            "label": "身份证号",
            "width": "170"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "telephone_number",
            "align": "center",
            "label": "电话号",
            "width": "110"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "gender",
            "align": "center",
            "label": "性别",
            "width": "60"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "post_name",
            "align": "center",
            "label": "岗位名称",
            "width": "130"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "align": "center",
            "label": "状态",
            "width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (scope.row.spare5 === '0'),
                  expression: "scope.row.spare5 === '0'"
                }],
                attrs: {
                  "src": require("../../../assets/未发放.png")
                }
              }), _vm._v(" "), _c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (scope.row.spare5 === '1'),
                  expression: "scope.row.spare5 === '1'"
                }],
                attrs: {
                  "src": require("../../../assets/待接收.png")
                }
              }), _vm._v(" "), _c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (scope.row.spare5 === '2'),
                  expression: "scope.row.spare5 === '2'"
                }],
                attrs: {
                  "src": require("../../../assets/待发放.png")
                }
              }), _vm._v(" "), _c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (scope.row.spare5 === '3'),
                  expression: "scope.row.spare5 === '3'"
                }],
                attrs: {
                  "src": require("../../../assets/已拆分.png")
                }
              }), _vm._v(" "), _c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (scope.row.spare5 === '4'),
                  expression: "scope.row.spare5 === '4'"
                }],
                attrs: {
                  "src": require("../../../assets/发放成功.png")
                }
              }), _vm._v(" "), _c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (scope.row.spare5 === '5'),
                  expression: "scope.row.spare5 === '5'"
                }],
                attrs: {
                  "src": require("../../../assets/发放失败.png")
                }
              }), _vm._v(" "), _c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (scope.row.spare5 === '6'),
                  expression: "scope.row.spare5 === '6'"
                }],
                attrs: {
                  "src": require("../../../assets/已代发.png")
                }
              }), _vm._v(" "), _c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (scope.row.spare5 === '7'),
                  expression: "scope.row.spare5 === '7'"
                }],
                attrs: {
                  "src": require("../../../assets/已代发.png")
                }
              })]
            }
          }], null, true)
        })], 1)]
      }
    }], null, false, 2191704462)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }], null, false, 1273622649)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "release_date",
      "align": "center",
      "label": "发放日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "superior_name",
      "align": "center",
      "label": "架构",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organize_name",
      "align": "center",
      "label": "项目名称",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewer_date",
      "align": "center",
      "label": "工资归属月",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "paid_amount",
      "align": "center",
      "label": "实发金额",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cash",
      "align": "center",
      "label": "现金",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bank_card",
      "align": "center",
      "label": "银行卡",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewer_name",
      "align": "center",
      "label": "薪酬制作人",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "agency_company",
      "align": "center",
      "label": "代发公司",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name_party_B",
      "align": "center",
      "label": "乙方名头",
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "30px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)])], 1) : _vm._e()])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02c7a2b0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gzhsgl/GzffHz/GzffHz.vue
// module id = null
// module chunks = 